export default "__VITE_ASSET__BInALPuj__"